import { Filter, Storage, Storefront } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import { List } from "@dzambalaorg/ui-kit";

import { StyledPaper } from "../styled";

const data = [
  { text: "pages.erc998.contracts.title", link: "/erc998/contracts", icon: <Storefront /> },
  { text: "pages.erc998.templates.title", link: "/erc998/templates", icon: <Filter /> },
  { text: "pages.erc998.tokens.title", link: "/erc998/tokens", icon: <Storage /> },
];

export const Erc998Section = () => {
  return (
    <StyledPaper>
      <List
        component="nav"
        subheader={
          <List.Subheader>
            <FormattedMessage id="pages.dashboard.hierarchy.erc998" />
          </List.Subheader>
        }
      >
        {data.map(({ text, icon, link }) => (
          <List.ItemButton<typeof RouterLink> key={text} component={RouterLink} to={link}>
            <List.ItemIcon>{icon}</List.ItemIcon>
            <List.ItemText>
              <FormattedMessage id={text} />
            </List.ItemText>
          </List.ItemButton>
        ))}
      </List>
    </StyledPaper>
  );
};
